import { useLayoutEffect, useRef, useState } from "react";

/** Custom controls must inherit native fieldset locks, including uncertain-save locks. */
export function useControlHost(disabled = false) {
  const ref = useRef<HTMLDivElement>(null);
  const [locked, setLocked] = useState(false);
  const [portal, setPortal] = useState<HTMLElement | null>(null);
  useLayoutEffect(() => {
    const host = ref.current;
    if (!host) return;
    const update = () => setLocked(Boolean(host.closest("fieldset[disabled]")));
    update();
    setPortal(host.closest("dialog") ?? document.body);
    const observer = new MutationObserver(update);
    for (let parent = host.parentElement; parent; parent = parent.parentElement) {
      if (parent.tagName === "FIELDSET") observer.observe(parent, { attributes: true, attributeFilter: ["disabled"] });
    }
    return () => observer.disconnect();
  }, []);
  return { ref, portal, disabled: disabled || locked,
    isLocked: () => disabled || Boolean(ref.current?.closest("fieldset[disabled]")) };
}
